import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import { hideModal } from '../../../actions/modal';
import {
  editProfileData,
  sendOTPMobile,
  updateEmail,
  otpForUpdateEmail,
  verifyOtpForUpdateEmail
} from '../../actions/personalInfo';
import { getFieldsFromDateAsFormat } from '../../../utils/dateFormatter';
import { signout } from '../../../userauth/actions/signinAction';
import { validateEmail, validatePassword } from '../../../utils/inputValidator';
import { isRilDomain } from '../../../utils/common';
import Loader from '../../../components/common/Loader';
import {
  getUaas,
  getAvailableDomainsFlag,
  getFraudReductionForEmployeeCouponsFlag,
  getFraudReductionForEmpCouponsLabels
} from '../../../refresh/selectors/featureFlagsSelector';
import { checkMyJioRedirection } from '../../../refresh/utils/myJioUtils';
import EmailVerify from '../../../refresh/atoms/EmailVerify';
import { gtmEventPushAccountInteraction } from '../../../modules/ga/GTMdatalayer';

class UpdateEmailIdPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      otp: '',
      newEmail: '',
      errEmail: '',
      otpValidMessage: '',
      disableCTA: true,
      showRilEmailMsg: false,
      showOtpForm: false,
      secondsRemaining: 60
    };
    this.modalRef = React.createRef();
    this.local = {
      timeout: ''
    };
  }
  focusInput = () => {
    if (this.modalRef.current) {
      this.modalRef.current.focus();
    }
  };
  _decrease(secLeft) {
    let timer = secLeft || this.state.secondsRemaining;
    if (timer > 0 && !this.state.errorMsg) {
      this.setState({ secondsRemaining: timer - 1 });
      this.local.timeout = setTimeout(this._decrease.bind(this), 1000);
    } else {
      this.local.timeout && clearTimeout(this.local.timeout);
      this.setState({ enableResendOTP: true });
    }
  }

  handleOtpSubmit = async e => {
    e.preventDefault();
    function isMobile() {
      let mobileDevice = false;
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      ) {
        mobileDevice = true;
      }
      return mobileDevice;
    }

    if (!this.state.otp) {
      this.setState({ otpValidMessage: 'Please enter OTP' });
      return;
    }
    const { otp, newEmail } = this.state;
    const data = { otp, emailId: newEmail.toLowerCase(), login: this.props?.uid };
    this.props.verifyOtpForUpdateEmail(data, () => {
      gtmEventPushAccountInteraction('update email address', 'new email id', 'request success');
      this.setState({ showOtpForm: false }, () => {
        const { history } = this.props;
        localStorage.setItem('emailUpdateMsg', 'Email address updated. Please Login');
        this.props.signout(() => {
          window.location = isMobile() ? '/login?referrer=/my-account/' : '/';
        })();
      });
    });
  };

  handleSubmit = async e => {
    e.preventDefault();
    ga('send', {
      eventCategory: 'buttonTap',
      eventAction: 'Change Personal Info',
      eventLabel: 'Save New Email Address'
    });
    if (this.state.newEmail && validateEmail(this.state.newEmail)) {
      let custProfile = {
        emailId: this.state.newEmail.toLowerCase(),
        mobileNumber: this.props.mobileNumber,
        isEmailUpdate: true
        // screenName: this.props.screenName
      };
      if (this.props.isUaas) {
        custProfile = {
          emailId: this.state.newEmail.toLowerCase(),
          mobileNumber: this.props.mobileNumber,
          isEmailUpdate: true
          // login: this.props?.uid
        };
      }
      this.setState({
        errEmail: ''
      });

      this.props.otpForUpdateEmail(custProfile, () => {
        this.setState({
          showOtpForm: true,
          secondsRemaining: 60
        });

        console.log(
          '🚀 ~ file: UpdateEmailIdPopup.js:62 ~ UpdateEmailIdPopup ~ this.props.otpForUpdateEmail ~ otpForUpdateEmail:',
          custProfile
        );
        this.focusInput()
        this._decrease();
      });
    } else if (!this.state.newEmail) {
      this.setState({
        errEmail: 'Please enter a new email ID.'
      });
    } else if (!validateEmail(this.state.newEmail)) {
      this.setState({
        errEmail: 'Please enter a valid email address.'
      });
    }
  };

  handleChange(field, value, errmessage = '') {
    const { disableCTA, newEmail, showOtpForm } = this.state;
    let cta = disableCTA;
    if (field === 'newEmail') {
      value !== '' && this.isRilUser(value);
      errmessage = '';
      if (value !== '') cta = false;
      else cta = true;
    }
    if (showOtpForm) {
      cta = false;
    }
    this.setState({
      [field]: value,
      disableCTA: cta,
      otpValidMessage: ''
    });
  }

  isRilUser = debounce(value => {
    const { availableDomains } = this.props;
    const isDomainlRil = isRilDomain(availableDomains, value);
    this.setState({ showRilEmailMsg: isDomainlRil });
  }, 1000);

  resendOTP = () => {
    const custProfile = {
      emailId: this.state.newEmail.toLowerCase(),
      mobileNumber: this.props.mobileNumber,
      isEmailUpdate: true
      // screenName: this.props.screenName
    };
    this.props.otpForUpdateEmail(custProfile, () => {
      this.setState({
        showOtpForm: true,
        secondsRemaining: 60,
        otpValidMessage: ''
      });
      this._decrease();
    });
  };

  render() {
    let { mobileNumber } = this.props;

    const { showOtpForm, otpValidMessage, otp } = this.state;
    let { error: { errorType = '', message: errmessage = '' } = {} } = this.props.httpError;
    const TEXT_MESSAGE = 'Valid for 10 mins';
    const RESEND_TEXT =
      this.state.secondsRemaining > 0
        ? `Resend OTP in <span>${this.state.secondsRemaining}s</span>`
        : 'Resend OTP';
    const CUSTOM_RESEND_CLASS = this.state.secondsRemaining === 0 ? 'reset-counter' : '';
    const CUSTOM_WIDTH_CLASS = this.state.secondsRemaining === 0 ? 'custom-wide' : '';
    let data = errmessage;
    return (
      <form
        className="update-mobile-form"
        id="updateEmailForm"
        noValidate
        onSubmit={showOtpForm ? this.handleOtpSubmit : this.handleSubmit}
        tabIndex={-1}
        ref={this.modalRef}
      >
        <Loader name="mobile-num-popup" />
        <p className="update-mobile-no-text" role='heading' aria-level={2}>
          <strong>
            {showOtpForm ? 'Enter OTP To Change Email Address' : 'Enter New Email Address'}{' '}
          </strong>
        </p>

        {showOtpForm ? (
          <div className="update-mob-input-field-block update-mob-oly">
            <div className="update-mobile-mod-type">
              <div className="afterOtpSection">
                <div className="text-mob-update">
                  Enter OTP sent to the new phone number <span>+91 {mobileNumber}</span>
                </div>
                <div className="new-phone-otp">
                  <input
                    className="update-mobile-mod-otp-input"
                    value={otp}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (/^\d*$/.test(val)) {   // Allow only numeric input
                        this.handleChange('otp', val, data);
                      }
                    }}
                    name="otp"
                    size="32"
                    maxLength="6"
                    type="text"
                    aria-label="Enter OTP"
                  />
                  <label htmlFor="otp">Enter OTP</label>
                </div>
                <div className="container-message otp-msg-left">
                  {errmessage ? (
                    <span className="error-msg" aria-live="polite">
                      {errmessage}
                    </span>
                  ) : !errmessage && otpValidMessage ? (
                    <span className="error-msg" aria-live="polite" role="alert">
                      {otpValidMessage}
                    </span>
                  ) : (
                    <span className="valid-for-min">{TEXT_MESSAGE}</span>
                  )}
                  <span
                    className="resend-counter"
                    dangerouslySetInnerHTML={{ __html: RESEND_TEXT }}
                    onClick={this.resendOTP}
                    role="button"
                    tabIndex={0}
                    aria-disabled={this.state.secondsRemaining > 0}
                    disabled={this.state.secondsRemaining > 0}
                    aria-label={this.state.secondsRemaining > 0 ? 'Resend OTP not available for 60 seconds' : 'Resend OTP'}
                    onKeyDown={event => {
                      if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        this.resendOTP();
                      }
                    }}
                  />
                </div>

                <div className="mobaddaddr-type">
                  <input
                    type="submit"
                    className="update-mobile-mod-verify add-margin"
                    value="CONFIRM OTP"
                  />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="update-mob-input-field-block">
            <div className="email-id">
              <input
                className="update-mobile-mod-input"
                name="newEmail"
                size="32"
                maxLength="254"
                type="email"
                value={this.state.newEmail}
                onChange={e => {
                  this.handleChange('newEmail', e.target.value, data);
                }}
                aria-label="Enter New Email"
                autoComplete="email"
              />
              <label htmlFor="newEmail" className="newEmailLabel">
                Email Address
              </label>
              {this.state.errEmail && (
                <div 
                  className="err-msg-email"
                  aria-live='polite'
                  role='alert'
                >
                    {this.state.errEmail}
                </div>)}
              {this.props.fraudReductionForEmployeeCouponsFlag &&
                this.props.isUaas &&
                this.state.showRilEmailMsg && (
                  <EmailVerify
                    ctaLabel={this.props.fraudReductionForEmpCouponsLabels?.updateRilEmpTxt}
                    sourceType="EDUCATE"
                  />
                )}
            </div>
            <div className="mobaddaddr-type">
              <input
                type="submit"
                disabled={this.state.disableCTA}
                placeholder="save"
                className="update-mobile-mod-verify update-email-popup"
                value="Send OTP for verification"
              />
            </div>
          </div>
        )}
      </form>
    );
  }
}
const mapStatetoProps = state => {
  const { personalInfo = {}, signInReducer = {}, httpError = {} } = state;
  const { validUser = false } = signInReducer;
  const {
    emailUpdate = {},
    profile: { screenName = '', uid = '', mobileNumber } = {}
  } = personalInfo;
  const { statusCode = '', message = '', type = '', success } = emailUpdate;
  const isMyJioRedirection = checkMyJioRedirection();
  const isUaas = getUaas(state) || isMyJioRedirection;
  const fraudReductionForEmployeeCouponsFlag = getFraudReductionForEmployeeCouponsFlag(state);
  const fraudReductionForEmpCouponsLabels = getFraudReductionForEmpCouponsLabels(state);
  const availableDomains = getAvailableDomainsFlag(state);
  return {
    statusCode,
    message,
    type,
    validUser,
    screenName,
    isUaas,
    fraudReductionForEmployeeCouponsFlag,
    fraudReductionForEmpCouponsLabels,
    uid,
    success,
    httpError,
    availableDomains,
    mobileNumber,
    personalInfo
  };
};
const mapDispatchToProps = dispatch => {
  return {
    editProfileData: formData => {
      dispatch(editProfileData(formData));
    },
    updateEmail: (formData, callback) => {
      dispatch(updateEmail(formData, callback));
    },
    otpForUpdateEmail: (formData, callback) => {
      dispatch(otpForUpdateEmail(formData, callback));
    },
    verifyOtpForUpdateEmail: (formData, callback) => {
      dispatch(verifyOtpForUpdateEmail(formData, callback));
    },
    signout: callback => {
      dispatch(signout(callback));
    },
    hideModal: name => {
      dispatch(hideModal(name));
    }
  };
};
export default UpdateEmailIdPopup = connect(
  mapStatetoProps,
  mapDispatchToProps
)(UpdateEmailIdPopup);
